<div>
    <div *ngIf="unlimitedPlanGroup">
        <div *ngFor="let unlimitedLine of unlimitedPlanGroup.unlimitedLines">
            <div class="data-charges">
                <div class="expand-style charge-group">
                    <div class="heading">
                        {{ unlimitedLine.planName }}
                    </div>
                </div>
            </div>
            <div class="data-charges">
                <div class="expand-style line-group" *ngFor="let line of unlimitedLine.lines">
                    <div class="heading">
                        <span>
                            {{ line.nickname }}
                        </span>
                    </div>
                    <div class="subheading">{{ line.phoneNumber | phone }}</div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="byTheGigPlanGroup">
        <div *ngFor="let byTheGigLine of byTheGigPlanGroup.byTheGigLines">
            <div class="data-charges">
                <div class="expand-style charge-group">
                    <div class="heading">
                        {{ byTheGigLine.planName }}
                    </div>
                </div>
            </div>
            <div class="data-charges">
                <div class="expand-style line-group" *ngFor="let line of byTheGigLine.lines">
                    <div class="heading">
                        <span>
                            {{ line.nickname }}
                        </span>
                    </div>
                    <div class="subheading">{{ line.phoneNumber | phone }}</div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="tabletPlanGroup">
        <div *ngFor="let tabletLine of tabletPlanGroup.tabletLines">
            <div class="data-charges">
                <div class="expand-style charge-group">
                    <div class="heading">
                        {{ tabletLine.planName }}
                    </div>
                </div>
            </div>
            <div class="data-charges">
                <div class="expand-style line-group" *ngFor="let line of tabletLine.lines">
                    <div class="heading">
                        <span>
                            {{ line.nickname }}
                        </span>
                    </div>
                    <div class="subheading">{{ line.phoneNumber | phone }}</div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="smartWatchPlanGroup">
        <div *ngFor="let smartWatchLine of smartWatchPlanGroup.watchLines">
            <div class="data-charges">
                <div class="expand-style charge-group">
                    <div class="heading">
                        {{ smartWatchLine.planName }}
                    </div>
                </div>
            </div>
            <div class="data-charges">
                <div class="expand-style line-group" *ngFor="let line of smartWatchLine.lines">
                    <div class="heading">
                        <span>
                            {{ line.nickname }}
                        </span>
                    </div>
                    <div class="subheading">{{ line.phoneNumber | phone }}</div>
                </div>
            </div>
        </div>
    </div>
</div>
